
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcutils.vcshare.factory:ShareHelper
   *
   * @description
   *
   */
  angular
    .module('vcutils.vcshare')
    .factory('ShareHelper', ShareHelper);
  
  
  ShareHelper.$inject = ['Share', '$uibModal', '$log', 'Rlog'];
  
  function ShareHelper(Share, $uibModal, $log, Rlog) {
    let ShareHelperBase = {};
    
    ShareHelperBase.editShare = editShare;
    ShareHelperBase.addShare = addShare;
    
    
    function addShare(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><shareform share="vm.share" parentsave="vm.childsave(share)" oncancel="vm.cancel()"></sharenew></div>',
        controllerAs: 'shareaCtrl',
        controller: ['share', function () {
          let vm = this;
          vm.share = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(share) {
            Share.$create(share).$then(function (newshare) {
              vm.created = true;
              success(newshare);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ share-helper.addShare: ', err);
              Rlog.error('vcutils.share', 'share-helper.addShare', 'Creation of new SV failed: ', {error: err, share: share});
              error(err);
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          share: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }
    
    
    function editShare(lshare) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><shareform share="shareeCtrl.share" parentsave="shareeCtrl.childsave(share)" oncancel="shareeCtrl.cancel()"></shareform></div>',
        controllerAs: 'shareeCtrl',
        controller: ['share', function (sshare) {
          let vm = this;
          vm.share = sshare;
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          
          function childsave(share) {
            // vm.share = angular.copy(share);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in share) {
              if (share.hasOwnProperty(key)) {
                vm.share[key] = share[key];
              }
            }
            
            if (vm.share.$hasPendingActions()) {
              vm.share.$cancel();
              vm.share.$save();
              cancel();
            }
            else {
              vm.share.$save();
              dialog.close();
            }
          }
          
          
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          share: function () {
            return lshare;
          }
        },
        size: 'lg'
      });
      return dialog;
    }
    
    return ShareHelperBase;
  }
}());
